export default __webpack_public_path__ + "static/media/FirstBoxIcon.80c329c4.gif";